import { makeStyles } from "@fluentui/react-components";
import IRichTextSection from "../../../models/page/pageComponents/IRichTextSection";

const useStyles = makeStyles({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        padding: "2rem 1rem",
        boxSizing: "border-box"
    },
    container: {
        width: "100%",
        maxWidth: "1200px"
    },
    content: {
        fontSize: "16px",
        lineHeight: "1.8",
        color: "var(--colorNeutralForeground1)",

        "& h1, & h2, & h3, & h4, & h5, & h6": {
            marginTop: "1.5rem",
            marginBottom: "1rem",
            lineHeight: "1.25"
        },

        "& h1": { fontSize: "2rem" },
        "& h2": { fontSize: "1.75rem" },
        "& h3": { fontSize: "1.5rem" },

        "& p": {
            marginTop: 0,
            marginBottom: "1rem"
        },

        "& ul, & ol": {
            marginTop: 0,
            marginBottom: "1rem",
            paddingLeft: "1.5rem"
        },

        "& li": {
            marginBottom: "0.5rem"
        },

        "& a": {
            color: "var(--colorBrandForegroundLink)",
            textDecoration: "underline"
        },

        "& img": {
            maxWidth: "100%",
            height: "auto",
            borderRadius: "8px",
            display: "block",
            margin: "1.5rem auto"
        },

        "& blockquote": {
            margin: "1.5rem 0",
            paddingLeft: "1rem",
            borderLeft: "4px solid var(--colorNeutralStroke2)",
            color: "var(--colorNeutralForeground2)"
        },

        "& table": {
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "1rem",
            display: "block",
            overflowX: "auto"
        },

        "& th, & td": {
            border: "1px solid var(--colorNeutralStroke2)",
            padding: "0.75rem",
            textAlign: "left"
        }
    }
});

export default function RichText(props: IRichTextSection) {
    const styles = useStyles();

    if (!props.content) return null;

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: props.content }}
                />
            </div>
        </div>
    );
}